import { Button, Space } from "@pankod/refine-antd";
import { useEffect } from "react";
import { BaseKey, useUpdate } from "@pankod/refine-core";
import { ACTIVE_DEPARTMENT_API, DEACTIVE_DEPARTMENT_API } from "api/baseApi";
import { openNotification } from "utils";
import { DepartmentProps } from "./interface";
import { EStatusNotification, MSG_NOTIFICATION } from "constants/constant";

const DepartmentActive = (props: DepartmentProps) => {
  const { setIsModalVisible, department } = props;
  const { mutate, data: activeData, isLoading: isLoadingActive } = useUpdate();

  const handleChangeActive = () => {
    if (department?.isActive === true) {
      mutate({
        resource: DEACTIVE_DEPARTMENT_API,
        id: department?.id,
        values: {
          name: department,
        },
      });
    } else {
      mutate({
        resource: ACTIVE_DEPARTMENT_API,
        id: department?.id as BaseKey,
        values: {
          name: department,
        },
      });
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (activeData?.data.status == 200) {
      openNotification(MSG_NOTIFICATION.SUCCESSFUL, activeData?.data?.message, EStatusNotification.SUCCESS);
      setIsModalVisible(false);
    }
  }, [activeData, setIsModalVisible]);

  return (
    <Space
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "baseline",
      }}
    >
      <div>
        You are about to change the Active Status of this{" "}
        <strong>Department</strong>. Please select <strong>Change</strong> to
        continue or <strong>Cancel</strong> to go back
      </div>
      <Space style={{ marginTop: 10 }}>
        <Button
          onClick={handleChangeActive}
          className="btn-create"
          style={{ marginRight: "10px", backgroundColor: "#" }}
          loading={isLoadingActive}
        >
          Change
        </Button>
        <Button onClick={handleCancel}>Cancel </Button>
      </Space>
    </Space>
  );
};

export default DepartmentActive;
